export default __webpack_public_path__ + "static/media/Promo.558f49f3.png";